import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Love, Hate, Fear, Happy, CryingFace } from './components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "animated-emojis"
    }}>{`Animated Emojis`}</h1>
    <div style={{
      display: "flex",
      padding: 20,
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: "space-between"
    }}>
 <Love size={10} mdxType="Love" />
 <Hate size={10} mdxType="Hate" />
 <Fear size={10} mdxType="Fear" />
 <Happy size={10} mdxType="Happy" />
 <CryingFace size={10} mdxType="CryingFace" />
    </div>
    <h2 {...{
      "id": "components"
    }}>{`Components`}</h2>
    <h3 {...{
      "id": "love"
    }}><a parentName="h3" {...{
        "href": "src-components-love"
      }}>{`Love`}</a></h3>
    <h3 {...{
      "id": "hate"
    }}><a parentName="h3" {...{
        "href": "src-components-hate"
      }}>{`Hate`}</a></h3>
    <h3 {...{
      "id": "fear"
    }}><a parentName="h3" {...{
        "href": "src-components-fear"
      }}>{`Fear`}</a></h3>
    <h3 {...{
      "id": "happy"
    }}><a parentName="h3" {...{
        "href": "src-components-happy"
      }}>{`Happy`}</a></h3>
    <h3 {...{
      "id": "crying-face"
    }}><a parentName="h3" {...{
        "href": "src-components-crying-face"
      }}>{`Crying Face`}</a></h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      